export default {
  bind (el, binding, vnode) {
    vnode.context.$nextTick(function () {
      const offsetbottom = el.getBoundingClientRect().bottom + window.scrollY
      let requesting = false

      binding.scroll = () => {
        if (!requesting) {
          requestAnimationFrame(frame)
          requesting = true
        }
      }

      function frame () {
        if (window.scrollY <= offsetbottom) {
          el.style = `transform: translateY(-${scrollY / binding.value.intensity}px)`
        }
        requesting = false
      }

      binding.scroll()
      window.addEventListener('scroll', binding.scroll)
    })
  },

  unbind (el, binding) {
    window.removeEventListener('scroll', binding.scroll)
  }
}
